import { ListItem, ListItemText } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useAppSelector } from 'app/hooks';
import { useDrop } from 'react-dnd';
import WallListItem from './WallListItem';

import { useWallsWithoutFolders } from 'features/walls/api/getWallsWithoutFolders';
import { useUpdateWall } from 'features/walls/api/updateWall';
import { WeatherWall, Wall } from 'types';
import { useWeatherWallsWithoutFolders } from 'features/weatherWalls/api/getWeatherWallsWithoutFolders';
import { useUpdateWeatherWall } from 'features/weatherWalls/api/updateWeatherWall';
import { queryClient } from 'lib/react-query';

interface Props {
  handleWallClicked: (wall: WeatherWall | Wall) => void;
  selectedWallId: number | undefined;
  weather?: boolean;
}

const WallsWithoutFoldersContainer = ({
  handleWallClicked,
  selectedWallId,
  weather,
}: Props) => {
  const user = useAppSelector((state) => state.auth.user);
  const { data: traceWalls } = useWallsWithoutFolders({
    userId: user?.id || -1,
  });
  const updateWallMutation = useUpdateWall({});
  const updateWeatherWallMutation = useUpdateWeatherWall({});
  const { data: weatherWalls } = useWeatherWallsWithoutFolders({
    userId: user?.id,
  });

  const wallsWithoutFolders = weather ? weatherWalls : traceWalls;

  const onDrop = async (item: { name: string }) => {
    if (weather) {
      await updateWeatherWallMutation.mutateAsync({
        wallId: Number(item.name),
        data: {
          folder_id: null,
          folder_position: null,
        },
      });
      queryClient.invalidateQueries(['weatherFolders']);
      queryClient.invalidateQueries(['weatherWalls']);
    } else {
      await updateWallMutation.mutateAsync({
        data: {
          folder_id: null,
          folder_position: null,
        },
        wallId: Number(item.name),
      });
      queryClient.invalidateQueries(['folders']);
      queryClient.invalidateQueries(['walls']);
    }
  };
  const [{ isOver }, drop] = useDrop({
    accept: 'WALL',
    drop: onDrop,
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });
  return (
    <div ref={drop}>
      {wallsWithoutFolders?.length === 0 && (
        <ListItem selected={isOver}>
          <ListItemText sx={{ color: grey[500], pl: '1rem' }}>
            Drag walls here to remove them from all folders
          </ListItemText>
        </ListItem>
      )}
      {wallsWithoutFolders?.map((wall) => (
        <WallListItem
          wall={wall}
          selected={isOver || selectedWallId === wall.id}
          handleWallClicked={handleWallClicked}
          key={wall.id + 'wall'}
        />
      ))}
    </div>
  );
};

export default WallsWithoutFoldersContainer;
